import { useMediaQuery, useTheme } from "@mui/material";

/**
 * Tek eşikli "mobil" kararı: md altı (<900px). Hamburger/overlay menü ve dialogların
 * tam ekran olması gibi mobil davranışlar bu hook'tan yönetilir; eşik tek yerde değişir.
 */
export const useIsMobile = () => useMediaQuery(useTheme().breakpoints.down("md"));
